import type { IHttpService, IAugmentedJQuery, IController, IScope, IHttpResponse } from "angular";

import type { IImageData } from "App/Modules/Models";

export default class SvgImageCanvasDirectiveCntroller implements IController {
    public static $inject = ["$scope", "$element", "$http"];

    public image: IImageData;
    private id: string; // unique id for each usage of this directive to prevent removal of wrong image

    constructor(private $scope: IScope, private $element: IAugmentedJQuery, private readonly $http: IHttpService) {}

    private fetchImage() {
        // Fetch image using access token
        this.$http
            .get(`${this.image.url}?timestamp=${new Date().getTime()}`, {
                responseType: "arraybuffer",
            })
            .then((imageGetResponse: IHttpResponse<ArrayBuffer>) => {
                // Create a blob and a URL reference to that blob
                const blob = new Blob([imageGetResponse.data], {
                    type: imageGetResponse.headers("content-type") || undefined,
                });
                const url = URL.createObjectURL(blob);

                // Remove existing image element before adding a new one (if exists)
                const existing = document.querySelector(`#${this.id}`);
                if (existing) {
                    existing.remove();
                }

                this.$element.after(`<img src="${url}"
                    height="${this.image.height}"
                    id="${this.id}"
                    width="${this.image.width}"
                    alt="${this.image.altText}"
                    class="image-layer">`);
            });
    }

    public $onInit() {
        this.id = `image-${Math.floor(Math.random() * 10000)}`;
        // Fetch new image when url changes
        this.$scope.$watch("$ctrl.image", () => {
            this.fetchImage();
        });
        this.$element.addClass("svg-layer");
    }
}
